'use client';

import { Input } from 'antd';
import { useRouter } from 'next/navigation';
import { FC, useCallback } from 'react';
import styles from './BlogJumbotron.module.scss';

const BlogSearch: FC = () => {
  const router = useRouter();

  const handleSearch = useCallback(
    (value: string) => {
      const trimmedValue = value.trim();
      if (!trimmedValue) {
        return;
      }
      const encodedQuery = encodeURIComponent(trimmedValue);
      router.push(`/blog/search?q=${encodedQuery}`);
    },
    [router],
  );

  return (
    <div className={styles.containerSearch}>
      <Input.Search
        placeholder="Search in blog, news, persona..."
        onSearch={(value) => handleSearch(value)}
        className={styles.search}
        allowClear
      />
    </div>
  );
};

export { BlogSearch };
